var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Vswitch", {
    attrs: { optList: _vm.optList },
    model: {
      value: _vm.innerValue,
      callback: function($$v) {
        _vm.innerValue = $$v
      },
      expression: "innerValue"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }